import { useSearchParams } from "react-router-dom";

export const useSearchTerm: () => [string, (term: string) => void] = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const searchTerm = searchParams.get("search") ?? "";

  const setSearchTerm = (term: string) => {
    setSearchParams(
      (oldParams) => {
        const params = new URLSearchParams(oldParams);
        params.set("search", term);
        return params;
      },
      { replace: true },
    );
  };

  return [searchTerm, setSearchTerm];
};
